import { useEffect } from 'react';
import { ADDITIONAL_MEDIA_ID_PREFIX } from '../constants';
import { hasWindow } from '../../utils/browser';
/** Checks and attempts to extract an index from window.location.hash and
 *  then calls `whenFound` on the `PapiAttachmentFile` at that index */ export function useMultiArtDeepLinking(additionalMedia, whenFound) {
    useEffect(()=>{
        // slice past '#'
        const hash = window.location.hash.slice(1);
        if (!hasWindow() || !hash.startsWith(ADDITIONAL_MEDIA_ID_PREFIX)) {
            return;
        }
        const hashIdIndexString = window.location.hash.slice(1).replace(ADDITIONAL_MEDIA_ID_PREFIX, '');
        let hashIdIndex = Number.parseInt(hashIdIndexString, 10);
        if (!Number.isSafeInteger(hashIdIndex) || hashIdIndex < 2) {
            return;
        }
        // adjust from nerd-based to people-based number system
        // and assume 1 is the main image (where we'd end up on page load anyway)
        hashIdIndex = hashIdIndex - 2;
        if (additionalMedia === null || additionalMedia === void 0 ? void 0 : additionalMedia[hashIdIndex]) {
            whenFound(additionalMedia === null || additionalMedia === void 0 ? void 0 : additionalMedia[hashIdIndex]);
        }
    }, [
        additionalMedia,
        whenFound
    ]);
}

//# sourceMappingURL=useMultiArtDeepLinking.js.map